// « Options acceptées · 200 MAD » — the accepted add-ons other than the Relief
// 3D (express delivery, accepted in the chat after the client approved her
// preview: owner, 2026-10-03, item 6).
//
// The worker bills them through `orders.addons_cost` (migration 188, the one
// pricing function), INSIDE total_price. Shown as its OWN line next to the
// Relief one, for the reason that line exists: a total the « Prix » breakdown
// cannot explain is a total nobody can explain to the client on the phone.
// The figure is the one the chat summary and the advance request quoted.
//
// Renders nothing when none was accepted. Guard: OrderExtrasLine.test.tsx
import type { Order } from '@/lib/api';
import { useT } from '@/lib/i18n';
import { formatPrice } from '@/lib/utils';

export function OrderExtrasLine({ order }: { order: Pick<Order, 'addons_cost'> }) {
  const { t } = useT();
  const cost = Number(order.addons_cost) || 0;
  if (cost <= 0) return null;
  return (
    <div>
      <dt className="text-xs text-gray-400 mb-0.5">{t('Options acceptées')}</dt>
      <dd className="font-medium text-gray-800 text-sm">
        {formatPrice(cost)}
        <span className="block text-[11px] font-normal text-gray-500">{t('Livraison express et autres options, hors Relief 3D — déjà dans le prix.')}</span>
      </dd>
    </div>
  );
}
